import { NgModule } from '@angular/core';
import { TypePipe } from './type-pipe.pipe';

@NgModule({
  declarations: [TypePipe],
  exports: [TypePipe],
})
export class TypePipeModule {}
